const type = 'SET_CARD_STATUS_CHANGE_SUBMITTING';

const setCardStatusChangeSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setCardStatusChangeSubmitting;
